import React from "react";
import { Container } from "./styles";

const Error = () => {
  return (
    <Container>
        <h2>404</h2>
        <p>Opsss.. página não encontrada.</p>
    </Container>
  )
}

export default Error;